/* Phase 7 — post-pair confirm card. Visual shape mirrors the Android
 * `PairConfirmCard` in apps/android/.../ui/main/components/PairConfirmCard.kt:
 * surface-container background, 12px radius, 16px padding, body text on
 * top with the auto-name bolded inline, and a row of action buttons
 * underneath. We don't reach for the existing `--reflecto-surface-*`
 * Material-token aliases here because the popup's token surface today
 * is `--bg-secondary` / `--stroke-neutral`, which already maps to the
 * same visual layer ("a card sat on top of the popup background").
 */

.card {
  border-radius: 12px;
  padding: var(--spacing-16);
  background: var(--bg-secondary);
  border: 1px solid var(--stroke-neutral);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-12);
  /* Sides/bottom from the container; top margin here — recapSlot has no top padding and the action bar is hidden on an empty inbox. */
  margin-top: var(--spacing-12);
}

.message {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-primary);
}

.actions {
  display: flex;
  gap: var(--spacing-8);
}

.dialogBackdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.dialog {
  background: var(--bg-primary);
  color: var(--text-primary);
  border-radius: 12px;
  padding: var(--spacing-16);
  min-width: 240px;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-12);
}

.dialogTitle {
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
}

.dialogLabel {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: var(--text-secondary);
}

.dialogInput {
  font: inherit;
  font-size: 14px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid var(--button-outline-stroke);
  background: var(--bg-primary);
  color: var(--text-primary);
}

.dialogError {
  color: var(--text-negative);
  font-size: 12px;
}

.dialogActions {
  display: flex;
  gap: var(--spacing-8);
  justify-content: flex-end;
}
